// @flow strict

import * as React from 'react';
import Iframe from '../Iframe';
import PageContentBlock from '../../internal/PageContentBlock';

type PropTypes = {|
  pardotFormUrl: string,
  title?: string,
|};

const Pardot = (props: PropTypes) => (
  <PageContentBlock title={props.title}>
    <Iframe src={props.pardotFormUrl} appliedMinHeight />
  </PageContentBlock>
);

export default Pardot;
